/**
 * @file コンポーネント：ページング ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Pagination = (props) => {
    /**
     * カレントを定義
     */
    const [currentIndex, setCurrentIndex] = useState(null);
    useEffect(() => {
        if (props.list.length > 0) {
            props.list.forEach((item, index) => {
                if (item.isCurrent) {
                    setCurrentIndex(index);
                }
            });
        }
    }, [props.list]);

    // Presenterに渡す
    return <Presenter {...props} currentIndex={currentIndex} />;
};
